import { render } from "./DynamicScroller.vue?vue&type=template&id=32f945c3"
import script from "./DynamicScroller.vue?vue&type=script&lang=js"
export * from "./DynamicScroller.vue?vue&type=script&lang=js"
script.render = render

export default script